import "angular";
import angular from "angular";
import { RestConfig as CommonConfig } from "./RestConfigInfo";

//customize ordinary BuilderView配置
let localConfig = {

}

//合并通用配置和ordinary BuilderView通用配置
export const RestConfig = angular.merge(CommonConfig, localConfig) as (typeof CommonConfig & typeof localConfig);